import React, { PropsWithChildren } from 'react';

import { FlexLayout } from '@swyftx/aviary/atoms/Layout/Flex';
import { Modal } from '@swyftx/aviary/atoms/Modal';
import { Tooltip, ToolTipProps } from '@swyftx/aviary/atoms/Tooltip/Tooltip';
import { Body } from '@swyftx/aviary/atoms/Typography';
import { useTailwindBreakpoint } from '@swyftx/aviary/hooks/useTailwindBreakpoint';

type Props = {
  name?: string;
} & ToolTipProps;

const EnhancedTooltip: React.FC<PropsWithChildren<Props>> = ({ name, title, content, children, ...rest }) => {
  const isDesktop = useTailwindBreakpoint('md', true);

  if (!content && !title) return <>{children}</>;

  if (!isDesktop) {
    return (
      <Modal
        triggerElement={children}
        title={name}
        position='bottom'
        blockOverlayClose={false}
        showCloseButton={false}
        className='z-modal-popover '
        overlayClassName='z-modal-popover-backdrop'
      >
        <FlexLayout direction='column' className='px-16 pb-16'>
          <Body color='secondary'>{title}</Body>
          <Body color='secondary'>{content}</Body>
        </FlexLayout>
      </Modal>
    );
  }

  return (
    <Tooltip {...rest} title={title} content={content}>
      {children}
    </Tooltip>
  );
};

export { EnhancedTooltip };
